import React, {useCallback, useState} from 'react';
import {Button, Container, Col, Row} from 'reactstrap';
import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';
import {faq} from './data.json';
import './FaqList.scss';

function FaqItem({id, question, answer, borderColor, ...props}) {
  return (
    <div className={classNames(`faq-item faq-item-border-${borderColor}`)}>
      <h3 className="section-heading faq-item-question">Q: {question}</h3>
      <p className="faq-item-answer">{answer}</p>
    </div>
  );
}

FaqItem.defaultProps = {
  borderColor: "black-15"
}

export default function FaqList({id, ...props}) {
  return faq
    .map(faq => <FaqItem {...faq} key={faq.id} {...props} />);
}
